import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { compatWrapper } from '@backstage/core-compat-api';
import { EnvironmentStatusCard } from './components/EnvironmentStatusCard';

/**
 * Entity-page card showing a NavOneQCoreEnvironment's live status (Phase 3, Task 4). Registered as
 * an EntityCardBlueprint extension so it slots into the standard entity page layout used by
 * @backstage/plugin-catalog/alpha (see packages/app/src/App.tsx).
 *
 * Wired for `kind: resource` with a `spec.type` ending in `-environment`, matching the `Resource`
 * entities NavOneQCoreEnvironmentEntityProvider (environment-status-backend/src/catalog) now emits
 * - one per NavOneQCoreEnvironment claim, named after the environment (matching the
 * `environments/<name>/claim.yaml` convention Task 3 already established). This closes the
 * AC3/catalog-entity gap flagged in the Phase 3 review: previously no entity provider existed
 * at all, so this card (originally filtered on `kind:component`) had nowhere real to render.
 */
export const environmentStatusCard = EntityCardBlueprint.make({
  name: 'environment-status',
  params: {
    type: 'info',
    // Every environment type ends in -environment (navone-, qcore-, navone-demo-); see
    // environmentEntityType in environment-status-backend/src/catalog.
    filter: entity =>
      entity.kind.toLowerCase() === 'resource' &&
      typeof entity.spec?.type === 'string' &&
      entity.spec.type.endsWith('-environment'),
    loader: () =>
      Promise.resolve(compatWrapper(<EnvironmentStatusCard />)),
  },
});

export const environmentStatusPlugin = createFrontendPlugin({
  pluginId: 'environment-status',
  extensions: [environmentStatusCard],
});

export default environmentStatusPlugin;
